"use client";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Grid,
  Card,
  Typography,
  Alert,
  IconButton,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Colors from "../../utility/Colors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Backdrop from "../../components/backdrop/index.tsx";
import { background_orange_gradient } from "../../assets/jss/material";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { TabContext, TabList } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import {
  finalStatusListThunk,
  saveOrUpdateCaseThunk,
  typeOfOrderThunk,
} from "./reducer/thunk";
import { useDispatch, useSelector } from "react-redux";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import constants, {
  formOrCourtArr,
  stateArray,
} from "../../common/constants.js";
import { getLocalDateTime } from "../../utility/common-functions.js";
import SavedSuccessModal from "./SavedSuccessModal.js";
import Methods from "../../utility/Methods.js";
import CloseIcon from "@mui/icons-material/Close";
import { resetSaveOrUpdateCase } from "./reducer/slice.js";
import SnackbarComponent from "../../components/snackbar/index.tsx";

const AddNewAward = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = Methods.getRole();
  const [value, setValue] = React.useState("1");
  const [files, setFiles] = useState();
  const [finalStatusArr, setFinalStatusArr] = useState([]);
  const [typeOfOrderArr, setTypeOfOrderArr] = useState([]);
  const [forumOrCourtArr, setForumOrCourt] = useState(formOrCourtArr);
  const [fileUploadModalOpen, setFileUploadModalOpen] = useState(false);
  const [fileValidationErr, setFileValidationErr] = useState({
    file_size: false,
    file_type: false,
  });
  const [savedSuccessModalOpen, setSavedSuccessModalOpen] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });
  const finalStatusList = useSelector(
    (state) => state.finalStatusList.finalStatusList
  );
  const typeOfOrder = useSelector((state) => state.finalStatusList.typeOfOrder);
  const saveOrUpdateCase = useSelector(
    (state) => state.finalStatusList.saveOrUpdateCase
  );

  const {
    status: finalStatusListStatus,
    data: finalStatusListData,
    error: finalStatusListError,
  } = finalStatusList;
  const {
    status: typeOfOrderStatus,
    data: typeOfOrderData,
    error: typeOfOrderError,
  } = typeOfOrder;

  const {
    status: saveOrUpdateCaseStatus,
    data: saveOrUpdateCaseData,
    error: saveOrUpdateCaseError,
  } = saveOrUpdateCase;

  useEffect(() => {
    dispatch(finalStatusListThunk({}));
    dispatch(typeOfOrderThunk({}));
  }, []);

  useEffect(() => {
    if (finalStatusListStatus === "succeeded") {
      const listData = finalStatusListData || [];
      setFinalStatusArr(listData);
    }
  }, [finalStatusListData]);

  useEffect(() => {
    if (typeOfOrderStatus === "succeeded") {
      const listData = typeOfOrderData || [];
      setTypeOfOrderArr(listData);
    }
  }, [typeOfOrderData]);

  useEffect(() => {
    if (saveOrUpdateCaseStatus === "succeeded") {
      setSavedSuccessModalOpen(true);
      dispatch(resetSaveOrUpdateCase());
    } else if (saveOrUpdateCaseStatus === "failed") {
      handleShowSnackbar(
        "error",
        saveOrUpdateCaseError?.error?.errorMessage
          ? saveOrUpdateCaseError?.error?.errorMessage
          : "An error occured!"
      );
      setFiles([]);
    }
    {
    }
  }, [saveOrUpdateCaseStatus]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity: severity,
      message: message,
    });
  };

  const handleSnackClose = () => {
    setSnackbarOpen({
      open: "",
      severity: "",
      message: "",
    });
  };

  const handleFileUpload = (e) => {
    console.log("Files....", e.target.files);
    let latestFiles = Array.from(e.target.files);
    let totalFiles = files ? files.concat(latestFiles) : latestFiles;
    if (totalFiles.length > 5) {
      totalFiles = totalFiles.slice(0, 5);
    }

    // File size validation (15mb = 5 * 1024 * 1024 bytes)
    // const maxFileSize = constants.File_MAX_SIZE;
    const maxFileSize = 15 * 1024 * 1024;
    const oversizedFiles = totalFiles.filter((file) => file.size > maxFileSize);
    const totalSize = totalFiles.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > 20 * 1024 * 1024) {
      // Set validation error for file size
      setFileValidationErr({
        ...fileValidationErr,
        file_size: true,
      });
      // Don't set the files if any are oversized
      return;
    }
    if (oversizedFiles.length > 0) {
      // Set validation error for file size
      setFileValidationErr({
        ...fileValidationErr,
        file_size: true,
      });

      // Don't set the files if any are oversized
      return;
    } else {
      // Clear validation errors if all files are valid
      setFileValidationErr({
        file_size: false,
        file_type: false,
      });
    }

    setFiles(totalFiles);
    //  Reset the input value so the same file can be selected again
    e.target.value = null;
  };

  const validationSchema = Yup.object({
    caseId: Yup.string().required("Required"),

    caseNumber: Yup.string()
      .matches(
        /^[a-zA-Z0-9\-/]+$/,
        "Only alphanumeric characters, hyphens (-), and slashes (/) are allowed"
      )
      .required("Required"),

    complainantName: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces are allowed")
      .required("Required"),

    policyNumber: Yup.string()
      .matches(
        /^[a-zA-Z0-9/]+$/,
        "Only alphanumeric characters and slashes (/) are allowed"
      )
      .required("Required"),
    dateOfAward: Yup.date()
      .typeError("Invalid date")
      .required("Required")
      .max(new Date(), "Date cannot be in the future"),
    dateOfReceiptAward: Yup.date()
      .typeError("Invalid date")
      .required("Required")
      .max(new Date(), "Date cannot be in the future"),
    principalClaimAmount: Yup.number()
      .required("Required")
      .max(99999999999, "Maximum amount limit reached"),
    finalStatus: Yup.string().required("Required"),
    location: Yup.string().required("Required"),
    state: Yup.string().required("Required"),
    forumOrCourt: Yup.string().required("Required"),
    reasonForRepudiation: Yup.string().required("Required"),
    typeOfOrder: Yup.string().required("Required"),
    senderComment: Yup.string().nullable(true),
  });

  const handleSubmitData = async (data) => {
    // Prevent submission if there are file validation errors
    if (fileValidationErr.file_size || fileValidationErr.file_type) {
      return;
    }

    const updateDetailsData = new FormData();
    updateDetailsData.append("caseNumber", data?.caseNumber);
    updateDetailsData.append("complainantName", data?.complainantName);
    updateDetailsData.append(
      "dateOfAward",
      getLocalDateTime(new Date(data?.dateOfAward))
    );
    updateDetailsData.append(
      "dateOfReceiptAward",
      getLocalDateTime(new Date(data?.dateOfReceiptAward))
    );
    updateDetailsData.append("finalStatus", data?.finalStatus);
    updateDetailsData.append("policyNumber", data?.policyNumber);
    updateDetailsData.append("typeOfOrder", data?.typeOfOrder);
    updateDetailsData.append("senderComment", data?.senderComment);
    updateDetailsData.append("state", data?.state);
    updateDetailsData.append("location", data?.location);
    updateDetailsData.append("forumOrCourt", data?.forumOrCourt);
    updateDetailsData.append(
      "reasonForRepudiation",
      data?.reasonForRepudiation
    );
    updateDetailsData.append(
      "principalClaimAmount",
      data?.principalClaimAmount
    );
    updateDetailsData.append(
      "reviewerRole",
      data.finalStatus.toUpperCase() === constants.LOST ||
        data.finalStatus.toUpperCase() === constants.SETTLEMENT
        ? constants.LEGAL_MANAGER
        : ""
    ); //!role will be diff here
    files && files[0] && updateDetailsData.append("file", files[0]);
    files && files[1] && updateDetailsData.append("file", files[1]);
    files && files[2] && updateDetailsData.append("file", files[2]);
    files && files[3] && updateDetailsData.append("file", files[3]);
    files && files[4] && updateDetailsData.append("file", files[4]);
    //api call for file upload
    dispatch(saveOrUpdateCaseThunk(updateDetailsData));
    setFiles([]);
  };

  const savedSuccessModalHandler = () => {
    setSavedSuccessModalOpen(false);
  };

  const submitClickHandler = async () => {
    navigate("/dashboard");
    savedSuccessModalHandler();
  };

  const sendToManager = () => {};

  // Check if form submission should be disabled
  const isSubmitDisabled =
    saveOrUpdateCaseStatus === "pending" ||
    fileValidationErr.file_size ||
    fileValidationErr.file_type;

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "fullWidth",
          //   minHeight: "100vh",
          marginTop: "10px",

          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Add New Award" value="1" />
            </TabList>
          </Box>
        </TabContext>
        <Formik
          initialValues={{
            caseId: 0,
            caseNumber: "",
            complainantName: "",
            policyNumber: "",
            dateOfAward: "",
            dateOfReceiptAward: "",
            finalStatus: "",
            state: "",
            location: "",
            typeOfOrder: "",
            forumOrCourt: "",
            reasonForRepudiation: "",
            principalClaimAmount: "",
            senderComment: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmitData(values);
          }}
        >
          {(props) => (
            <Form>
              <Grid container spacing={4} sx={{ p: 1, mt: 4 }}>
                {[
                  {
                    name: "caseNumber",
                    label: "Case Number",
                    type: "input",
                    required: true,
                  },
                  {
                    name: "complainantName",
                    label: "Complainant Name",
                    type: "input",
                    required: true,
                  },
                  {
                    name: "policyNumber",
                    label: "Policy Number",
                    type: "input",
                    required: true,
                  },
                  { name: "dateOfAward", label: "Date Of Award", type: "date" },
                  {
                    name: "dateOfReceiptAward",
                    label: "Date Of Reciept Award",
                    type: "date",
                    required: true,
                  },
                  {
                    name: "typeOfOrder",
                    label: "Type Of Order",
                    type: "select",
                    required: true,
                  },

                  {
                    name: "finalStatus",
                    label: "Final Status",
                    type: "select",
                    required: true,
                  },
                  {
                    name: "location",
                    label: "Location",
                    type: "input",
                    required: true,
                  },
                  {
                    name: "state",
                    label: "State",
                    type: "select",
                    required: true,
                  },
                  {
                    name: "forumOrCourt",
                    label: "Forum/Court",
                    type: "select",
                    required: true,
                  },
                  {
                    name: "reasonForRepudiation",
                    label: "Reason for Repudiation",
                    type: "input",
                    required: true,
                  },
                  {
                    name: "principalClaimAmount",
                    label: "Principal Claim Amount",
                    type: "input",
                    required: true,
                  },
                  {
                    name: "senderComment",
                    label: "Comment",
                    type: "textArea",
                  },
                ].map((field) => (
                  <>
                    {field?.type === "input" ? (
                      <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <TextField
                              {...formikField}
                              variant="outlined"
                              size="small"
                              label={field.label}
                              required={field?.required}
                              type={
                                field.type === "checkbox" ? "checkbox" : "text"
                              }
                              fullWidth
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                            />
                          )}
                        </Field>
                      </Grid>
                    ) : field.type === "textArea" ? (
                      <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <TextField
                              {...formikField}
                              variant="outlined"
                              size="small"
                              multiline
                              rows={4}
                              label={field.label}
                              fullWidth
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                            />
                          )}
                        </Field>
                      </Grid>
                    ) : field.type === "select" ? (
                      <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <TextField
                              {...formikField}
                              variant="outlined"
                              fullWidth
                              size="small"
                              required={field?.required}
                              label={field.label}
                              sx={{ width: "100%" }}
                              //   renderValue={(selected) => {
                              //     if (selected.length === 0) {
                              //       return <em>Placeholder</em>;
                              //     }

                              //     return selected.join(", ");
                              //   }}
                              select
                              onChange={(event) => {
                                props.setFieldValue(
                                  field.name,
                                  event.target.value
                                );
                              }}
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                            >
                              {(field.name === "finalStatus"
                                ? finalStatusArr
                                : field.name === "state"
                                ? stateArray
                                : field.name === "forumOrCourt"
                                ? forumOrCourtArr
                                : typeOfOrderArr
                              )?.map((val) => {
                                return (
                                  <MenuItem key={val} value={val}>
                                    {val}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          )}
                        </Field>
                      </Grid>
                    ) : field.type === "date" ? (
                      field.name === "dateOfReceiptAward" ? (
                        <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDayjs}
                                adapterLocale="en-gb"
                              >
                                <DatePicker
                                  {...field}
                                  format="DD/MM/YYYY"
                                  label={field.label}
                                  disableFuture
                                  value={
                                    props.values.dateOfReceiptAward || null
                                    //  props.values.dateOfReceiptAward
                                    //   ? dayjs(props.values.dateOfReceiptAward)
                                    //   : null
                                  }
                                  onChange={(value) =>
                                    props.setFieldValue(field.name, value)
                                  }
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "small",
                                      error: Boolean(meta.error),
                                      helperText: meta.touched && meta.error,
                                      required: true,
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            )}
                          </Field>
                        </Grid>
                      ) : (
                        <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  {...field}
                                  format="DD/MM/YYYY"
                                  label={field.label}
                                  disableFuture
                                  value={props.values.dateOfAward || null}
                                  onChange={(value) =>
                                    props.setFieldValue(field.name, value)
                                  }
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "small",
                                      error: Boolean(meta.error),
                                      helperText: meta.touched && meta.error,
                                      required: true,
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            )}
                          </Field>
                        </Grid>
                      )
                    ) : null}
                  </>
                ))}

                <Grid item size={{ xs: 12, md: 4 }} sx={{ mt: 2 }}>
                  <Grid xs={12}>
                    <label htmlFor="file-input">
                      <CloudUploadIcon
                        fontSize="large"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                      />
                      <br />
                      Upload Files
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      accept="image/jpeg,image/png,application/pdf"
                      name="files[]"
                      multiple
                      onChange={handleFileUpload}
                      style={{
                        display: "none",
                      }}
                    />
                    <br />

                    {/* File validation error display */}
                    {fileValidationErr.file_size && (
                      <Alert severity="error" sx={{ mt: 1, mb: 1 }}>
                        Each file must be under 15MB, and total upload size must
                        not exceed 20MB.
                      </Alert>
                    )}

                    {files && files.length > 0 ? (
                      <span>
                        Selected Files:{" "}
                        {Object.keys(files).map((val) => {
                          return (
                            <span
                              key={val}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                              }}
                            >
                              <Typography
                                key={val}
                                variant="subtitle2"
                                sx={{ overflowWrap: "break-word" }}
                              >
                                {files[val]?.name} (
                                {(files[val]?.size / (1024 * 1024)).toFixed(2)}{" "}
                                MB)
                              </Typography>
                              <IconButton
                                size="small"
                                aria-label="Remove file"
                                onClick={() => {
                                  const newFiles = files.filter(
                                    (_, idx) => idx !== Number(val)
                                  );
                                  setFiles(newFiles);
                                }}
                              >
                                <CloseIcon color="warning" />
                              </IconButton>
                            </span>
                          );
                        })}
                      </span>
                    ) : null}

                    {/* File size limit information */}
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{ display: "block", mt: 1 }}
                    >
                      Maximum file size: 15MB per file
                    </Typography>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{ display: "block", mt: 1 }}
                    >
                      Total maximum file size: 20MB (All files)
                    </Typography>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{ display: "block", mt: 1 }}
                    >
                      Maximum file count: 5 Files
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* <Button onClick={openHandler}>Cancel</Button> */}
              <Grid
                container
                spacing={2}
                sx={{ p: 1 }}
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  sx={{
                    // ...background_orange_gradient,
                    borderRadius: "10px",
                    background: "rgb(245, 132, 31)",
                    color: Colors.WHITE,
                    px: 6,
                    my: 5,

                    borderRadius: "10px",
                    "&:hover": { opacity: 0.9 },
                  }}
                  type="submit"
                  disabled={isSubmitDisabled}
                >
                  {(props.values.finalStatus.toUpperCase() === constants.LOST ||
                    props.values.finalStatus.toUpperCase() ===
                      constants.SETTLEMENT) &&
                  role !== constants.LEGAL_MANAGER
                    ? "Submit to manager"
                    : "Submit"}
                </Button>
                <Button
                  sx={{
                    px: 6,
                    my: 5,
                    borderRadius: "10px",
                    "&:hover": { opacity: 0.9 },
                  }}
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                  variant="outlined"
                >
                  Cancel
                </Button>
              </Grid>
            </Form>
          )}
        </Formik>
        {saveOrUpdateCaseStatus === "pending" ? <Backdrop /> : null}{" "}
        {savedSuccessModalOpen && (
          <SavedSuccessModal
            savedSuccessModalOpen={savedSuccessModalHandler}
            handleSubmit={submitClickHandler}
            closeModal={() => setSavedSuccessModalOpen(false)}
            message={saveMessage}
          />
        )}
        {
          <SnackbarComponent
            message={snackbarOpen?.message}
            isOpen={snackbarOpen?.open}
            purpose={snackbarOpen?.severity}
            handleClick={handleSnackClose}
          />
        }
      </Card>
    </div>
  );
};

export default AddNewAward;
